import { Utils } from "@/plugins/utils"
import qs from 'qs';
import moment from "moment";


export default {
	namespaced: true,
	state: {
		lstLx8: [],
		loading: false,
		limit: 20,
		currentPage: 1,
		hasNext: false,
		filters: {
			likeSearch: "",
			actions: [],
			startDate: moment().format("YYYY-MM-DD 00:00"),
			endDate: moment().format("YYYY-MM-DD 23:59"),
		},
	},
	getters: {
		getlstLx8: state => state.lstLx8,
		getLoading: state => state.loading,
		getPagination: state => ({
			limit: state.limit,
			offset: state.offset,
			hasNext: state.hasNext,
		}),
		getFilters: state => state.filters,
	},
	mutations: {
		setParamsDataTable(state, payload) {
			state.lstLx8 = payload.items
			state.hasNext = payload.hasNext
		},
		setlstLx8(state, payload) {
			state.lstLx8 = payload.items
			state.limit = payload.limit
			state.offset = payload.offset
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setActionFilters(state, newActions){
			state.filters = {
				actions: newActions,
				...state.filters,
			}
		}
	},
	actions: {
		async search({ commit, state, dispatch }) {
			commit("setLoading", true)

			const params = {
				...state.filters,
				limit: state.limit,
				page: state.currentPage
			};

			try {
				const response = await this._vm.$axios.get('OryxPdv/AuditLog/Search', {
					params,
					paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
				});

				const payload = Utils.ValidateAxiosResponse(response.data)
				commit("setParamsDataTable", payload)
				return true
			} catch (error) {
				commit("setlstLx8", { items: [], limit: 20, offset: 0, hasNext: false })
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			} finally {
				commit("setLoading", false)
			}
		},
		async insert({ dispatch }, lx8) {
			try {
				const response = await this._vm.$axios.post('OryxPdv/AuditLog/Insert', lx8);
				return Utils.ValidateAxiosResponse(response.data);
			} catch (error) {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true });
				return false;
			}
		}
	},
}
